import { Action } from '@ngrx/store';
import { ILocationConfigUnit } from '../../models/location-config.interface';
import { IHauler, IHaulersReq, IHaulersRes } from '@cemex-core/cmx-api/models/hauler';

export const LOAD_INITIAL_STATE = '[Haulers] Load initial state';
export const LOAD = '[Haulers] Load';
export const LOAD_COMPLETE = '[Haulers] Load Complete';
export const LOAD_FAIL = '[Haulers] Load Fail';
export const SET = '[Haulers] Set';
export const REMOVE_SELECTED_HAULER = '[Haulers] Remove Selected';
export const RESET = '[Haulers] Reset';

export class HaulersLoadInitialState implements Action {
  readonly type = LOAD_INITIAL_STATE;

  constructor(public payload: ILocationConfigUnit) {}
}

export class HaulersLoadAction implements Action {
  readonly type = LOAD;

  constructor(public payload: IHaulersReq) {}
}

export class HaulersLoadCompleteAction implements Action {
  readonly type = LOAD_COMPLETE;

  constructor(public payload: IHaulersRes) {}
}

export class HaulersLoadFailAction implements Action {
  readonly type = LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class HaulerSetAction implements Action {
  readonly type = SET;

  constructor(public payload: IHauler) {}
}

export class RemoveSelectedHauler implements Action {
  readonly type = REMOVE_SELECTED_HAULER;

  constructor(public payload: null) {}
}

export class HaulerResetAction implements Action {
  readonly type = RESET;

  constructor() {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type HaulerActions =
  | HaulersLoadInitialState
  | HaulersLoadAction
  | HaulersLoadCompleteAction
  | HaulersLoadFailAction
  | HaulerSetAction
  | HaulerResetAction
  | RemoveSelectedHauler;
